mutation updateTopic($input: UpdateTopicInput!) {
  topic: updateTopic(input: $input) {
    id
    name
    description
    status
    isSystemGenerated
    isUserEditable
    landingpage {
      id
      slug
    }
  }
}
